import { render, staticRenderFns } from "./MyLicense.vue?vue&type=template&id=7b9da56f&"
import script from "./MyLicense.vue?vue&type=script&lang=js&"
export * from "./MyLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports